import React from "react";
import { Globe, Lock, Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSubscription } from "@/context/SubscriptionContext";
import { useAuth } from "@/context/AuthContext";

export const Header = ({ onOpenSubscribe }) => {
  const { lang, setLang, t } = useLang();
  const { subscribed } = useSubscription();
  const { user } = useAuth();
  const isSubscribed = subscribed || user?.subscription_active;

  return (
    <header className="hidden md:flex relative z-20 items-start justify-between px-6 md:px-14 pt-8 pb-4">
      {/* Trust marker */}
      <div className="flex items-start gap-3 max-w-[220px]" data-testid="trust-marker">
        <Globe size={22} className="text-[#C1A661] mt-0.5 shrink-0" strokeWidth={1.2} />
        <p className="text-[11px] leading-snug text-[#A1A7B3] tracking-wide font-light">
          {t.trust}
        </p>
      </div>

      {/* Right cluster */}
      <div className="flex flex-col items-end gap-3">
        <div className="flex rounded-full border border-[#C1A661]/25 overflow-hidden backdrop-blur-sm" data-testid="lang-switcher">
          <button
            data-testid="lang-en-btn"
            onClick={() => setLang("en")}
            className={`px-4 py-1.5 text-xs tracking-[0.2em] font-medium transition-colors duration-200 ${
              lang === "en" ? "bg-[#C1A661]/15 text-[#E2CFA4]" : "text-[#A1A7B3] hover:text-[#E2CFA4]"
            }`}
          >
            <span className="mr-1.5">🇬🇧</span>EN
          </button>
          <div className="w-px bg-[#C1A661]/25" />
          <button
            data-testid="lang-fr-btn"
            onClick={() => setLang("fr")}
            className={`px-4 py-1.5 text-xs tracking-[0.2em] font-medium transition-colors duration-200 ${
              lang === "fr" ? "bg-[#C1A661]/15 text-[#E2CFA4]" : "text-[#A1A7B3] hover:text-[#E2CFA4]"
            }`}
          >
            <span className="mr-1.5">🇫🇷</span>FR
          </button>
        </div>

        {isSubscribed ? (
          <div
            data-testid="subscribed-badge"
            className="flex items-center gap-2.5 rounded-full border border-[#C1A661]/50 bg-[#C1A661]/10 px-5 py-2 text-xs tracking-[0.25em] uppercase text-[#E2CFA4]"
          >
            <Check size={13} strokeWidth={1.8} className="text-[#C1A661]" />
            <span>{t.subscribedBadge}</span>
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <button
              data-testid="premium-cta-btn"
              onClick={onOpenSubscribe}
              className="group flex items-center gap-2.5 rounded-full border border-[#C1A661]/40 hover:border-[#C1A661] px-5 py-2 text-xs tracking-[0.25em] uppercase text-[#E2CFA4] hover:text-[#F8F5EE] transition-colors duration-200"
            >
              <Lock size={13} strokeWidth={1.5} className="text-[#C1A661] group-hover:text-[#E2CFA4]" />
              <span>{t.premiumCta}</span>
            </button>

            <button
              data-testid="subscribe-header-btn"
              onClick={onOpenSubscribe}
              className="rounded-full bg-[#C1A661] hover:bg-[#E2CFA4] px-6 py-2 text-xs tracking-[0.25em] uppercase text-[#050B1E] font-semibold transition-colors duration-200"
            >
              {t.subscribeCta}
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
